import { useState } from "react";

export const Footer = () => {
    const [isAboutExpanded, setIsAboutExpanded] = useState(false);
    function toggleIsAboutExpanded() {
        setIsLegalExpanded(false);
        setIsAboutExpanded(!isAboutExpanded);
    }
    const [isLegalExpanded, setIsLegalExpanded] = useState(false);
    function toggleIsLegalExpanded() {
        setIsAboutExpanded(false);
        setIsLegalExpanded(!isLegalExpanded);
    }
    return (
        <footer className="footer" id="js-footer">
            <div className="container footer--container">
                <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-3">
                        <div className={`footer-links ${isAboutExpanded ? "footer-links__open" : ""}`}>
                            <div className="footer-links__heading" onClick={toggleIsAboutExpanded}>
                                <span className="area-title">About the BMA</span>
                                <svg className="icon icon--chevron icon--medium">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M8 16.6L9.4 18l6-6-6-6L8 7.4l4.6 4.6z" />
                                    </svg>
                                </svg>
                            </div>
                            <ul className="footer-links-list">
                                <li className="footer-links-list-item">
                                    <a
                                        className="footer-links-list-item__link"
                                        target="_blank"
                                        href="https://www.bma.org.uk/about-us/contact-us/get-in-touch/contact-us"
                                        title="Contact us"
                                    >
                                        Contact us
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-3">
                        <div className={`footer-links ${isLegalExpanded ? "footer-links__open" : ""}`}>
                            <div className="footer-links__heading" onClick={toggleIsLegalExpanded}>
                                <span className="area-title">Legal</span>
                                <svg className="icon icon--chevron icon--medium">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M8 16.6L9.4 18l6-6-6-6L8 7.4l4.6 4.6z" />
                                    </svg>
                                </svg>
                            </div>
                            <ul className="footer-links-list">
                                <li className="footer-links-list-item">
                                    <a
                                        className="footer-links-list-item__link"
                                        target=""
                                        href="/termsandcondition"
                                        title="Terms of use"
                                    >
                                       Terms of use 
                                    </a>
                                </li>
                                <li className="footer-links-list-item">
                                    <a
                                        className="footer-links-list-item__link"
                                        target="_blank"
                                        href="https://www.bma.org.uk/privacy-policy"
                                        title="Privacy policy"
                                    >
                                     Privacy policy   
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}